import Cookies from 'js-cookie'
import Login from '../components/Login.vue'
import MainLayout from '../layouts/MainLayout.vue'
import { createRouter, createWebHashHistory } from 'vue-router'

// 页面组件 - 修改后的组件导入（添加前缀）
import AppDashboard from '../views/Dashboard.vue'
import AccountManagement from '../views/AccountManagement.vue'
import ArticleCategory from '../views/article/Category.vue'
import ArticleCreate from '../views/article/Create.vue'
import ArticleGreenbook from '../views/article/GreenbookCreate.vue'
import ArticleList from '../views/article/List.vue'
import ArticleRewrite from '../views/ArticleRewrite.vue'
import GreenbookDraft from '../views/greenbook/Draft.vue'
import GreenbookRecord from '../views/greenbook/Record.vue'
import PublishDraft from '../views/publish/Draft.vue'
import PublishRecord from '../views/publish/Record.vue'
import MaterialTitle from '../views/material/Title.vue'
import MaterialGallery from '../views/material/Gallery.vue'
import MaterialHeaderAd from '../views/material/HeaderAd.vue'
import MaterialFooterAd from '../views/material/FooterAd.vue'
import MaterialCall from '../views/material/Call.vue'
import MaterialKnowledge from '../views/material/Knowledge.vue'
import SystemModel from '../views/system/Model.vue'
import SystemTitleApi from '../views/system/TitleApi.vue'
import SystemMediumApi from '../views/system/MediumApi.vue'
import SystemMoban from '../views/system/Moban.vue'
import SystemCommand from '../views/system/Command.vue'
import SystemPublish from '../views/system/Publish.vue'
import SystemClever from '../views/system/Clever.vue'
import SystemOssConfig from '../views/system/OssConfig.vue'
import ConsumptionLog from '../views/ConsumptionLog.vue'

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/quick-login',
    name: 'QuickLogin',
    component: () => import('../views/QuickLogin.vue')
  },
  {
    path: '/',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      // 控制台
      {
        path: 'dashboard',
        name: 'AppDashboard',  // 修改名称
        component: AppDashboard
      },

      // 账号管理（已符合规范，无需修改）
      {
        path: 'account',
        name: 'AccountManagement',
        component: AccountManagement
      },

      // 文章管理
      {
        path: 'article',
        children: [
          {
            path: 'category',
            name: 'ArticleCategory',
            component: ArticleCategory
          },
          {
            path: 'create',
            name: 'ArticleCreate',
            component: ArticleCreate
          },
          {
            path: 'greenbook',
            name: 'ArticleGreenbook',  // 修改名称
            component: ArticleGreenbook
          },
          {
            path: 'list',
            name: 'ArticleList',
            component: ArticleList
          }
        ]
      },

      // 爆文改写
      {
        path: 'rewrite',
        name: 'ArticleRewrite',
        component: ArticleRewrite
      },

      // 绿书发布
      {
        path: 'greenbook',
        children: [
          {
            path: 'draft',
            name: 'GreenbookDraft',
            component: GreenbookDraft
          },
          {
            path: 'record',
            name: 'GreenbookRecord',
            component: GreenbookRecord
          }
        ]
      },

      // 文章发布
      {
        path: 'publish',
        children: [
          {
            path: 'draft',
            name: 'PublishDraft',
            component: PublishDraft
          },
          {
            path: 'record',
            name: 'PublishRecord',
            component: PublishRecord
          }
        ]
      },

      // 素材管理
      {
        path: 'material',
        children: [
          {
            path: 'title',
            name: 'MaterialTitle',
            component: MaterialTitle
          },
          {
            path: 'gallery',
            name: 'MaterialGallery',
            component: MaterialGallery
          },
          {
            path: 'header-ad',
            name: 'MaterialHeaderAd',
            component: MaterialHeaderAd
          },
          {
            path: 'footer-ad',
            name: 'MaterialFooterAd',
            component: MaterialFooterAd
          },
          {
            path: 'call',
            name: 'MaterialCall',
            component: MaterialCall
          },
          {
            path: 'knowledge',
            name: 'MaterialKnowledge',
            component: MaterialKnowledge
          }
        ]
      },

      // 消费日志
      {
        path: 'consumption-log',
        name: 'ConsumptionLog',
        component: ConsumptionLog
      },

      // 系统配置
      {
        path: 'system',
        children: [
          {
            path: 'model',
            name: 'SystemModel',
            component: SystemModel
          },
          {
            path: 'title-api',
            name: 'SystemTitleApi',
            component: SystemTitleApi
          },
          {
            path: 'medium-api',
            name: 'SystemMediumApi',
            component: SystemMediumApi
          },
          {
            path: 'Moban',
            name: 'SystemMoban',
            component: SystemMoban
          },
          {
            path: 'command',
            name: 'SystemCommand',
            component: SystemCommand
          },
          {
            path: 'OssConfig',
            name: 'SystemOssConfig',
            component: SystemOssConfig
          },
          {
            path: 'clever',
            name: 'SystemClever',
            component: SystemClever
          },
          {
            path: 'publish',
            name: 'SystemPublish',
            component: SystemPublish
          }
        ]
      }
    ]
  }
]


const router = createRouter({
  history: createWebHashHistory('/shop/'),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const isAuthenticated = Cookies.get('user_token')
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isLoginPage = to.path === '/login'

  // 认证检查逻辑
  if (requiresAuth) {
    if (isAuthenticated) {
      // 已认证访问管理后台
      if (to.path === '/') {
        // 默认跳转控制台
        next('/dashboard')
        return
      }
      next()
    } else {
      // 未认证重定向到登录页
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
  } else if (isLoginPage) {
    // 登录页特殊处理
    if (isAuthenticated) {
      next('/dashboard') // 已登录强制跳转控制台
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router